export function createRenderProgram({ elements = [], tracks = [], clear = null, meta = {} } = {}) {
  return {
    elements,
    tracks,
    clear,
    meta,
  };
}
